import { render, staticRenderFns } from "./addzian_link.vue?vue&type=template&id=313284e0&scoped=true&"
import script from "./addzian_link.vue?vue&type=script&lang=js&"
export * from "./addzian_link.vue?vue&type=script&lang=js&"
import style0 from "./addzian_link.vue?vue&type=style&index=0&id=313284e0&prod&lang=css&"
import style1 from "./addzian_link.vue?vue&type=style&index=1&id=313284e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313284e0",
  null
  
)

export default component.exports